module.exports =
  'COMMONHEADER':
    'NEWS': 'GN+ マガジン'
    'LOGOUT': 'ログアウト'
    'MYSCOREBOOK': 'マイスコアブック'
    'FAQ': 'FAQ（準備中)'
  'TERMS_OF_USE':
    'TITLE': '利用規約およびプライバシーポリシーへのご同意依頼'
    'BODY_1': '利用規約およびプライバシーポリシーの内容が更新されました。'
    'BODY_2': '内容をご確認、ご同意の上、引き続きサービスをご利用ください。'
    'BODY_3': '※必ず下記のリンクをクリックし、リンク先のページの内容をご確認ください。'
    'LINK_TERMS': '利用規格'
    'LINK_PRIVACY': 'プライバシーポリシー'
    'CHECKBOX': '個人情報の利用に関する個別同意事項に同意する'
    'BUTTON': '引き続きサービスを利用する'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-header/i18n/ja.coffee